import React, { useEffect, useState } from 'react';
import { getItem, removeItem, setItem } from '../../utils/localStorage';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useNavigate } from 'react-router-dom';
import {
  actionplansCount,
  fetchNotifications,
} from './../../requests/actionPlan';
import { assessments } from '../Dashboard/apiCaller';
import { selfAssessmentsDashboardList } from './../../requests/myActions';
import { checkNotificationClickAnalizer } from '../Notifications/Notifications.utils';
import { PatternIcon } from './PatternIcon';
import CurvedText from './CurvedText';
import NoNotification from '../../components/Notifications/NoNotification';
import AccessDenied from '../AccessDenied';
import { SetDefaultTemplateId } from '../commons/Header/SetDefaultTemplateId';
import { AuthMeRes } from '../commons/NotificationBell/AuthMeRes';
import {
  getBrandAndHotelData,
  userHotelDetails,
} from '../../helpers/handleBrandAndHotelData';
import {
  getInitialHotelSelectionData,
  updateHotelSelection,
} from '../../helpers/hotelSelectorHelpers';
import { BottomSheet } from '../../app/common/sharedComponents/BottomSheet';
import { ButtonBlockColumn } from './../../app/common/sharedStyledComponents/GenericStyles.styled';
import { ButtonLarge } from '../../app/common/sharedComponents/buttons/ButtonLarge';
import { useTranslation } from 'react-i18next';
import {
  MenuContainer,
  ContentArea,
  TextWrapper,
  NoNotificationContents,
  NotificationContainer,
  NotificationHeading,
  NotificationEmpty,
  ButtonContainer,
  OverdueCountsContent,
  RedDotContaier,
  BottomSheetContainer,
  ControlSelectContainer,
  ChartContainer,
  LeftTopDetail,
  RightTopDetail,
  BottomDetail,
  CenterDetail,
  OverdueCountsContainer,
  TextMyAuditCount,
  TextCreatNew,
} from './MyActions.styled';
import { HeaderContainer } from './../../app/common/sharedStyledComponents/MyAuditGenericStyles.styled';
import { NotificationList } from '../../app/common/sharedComponents/NotificationList';
import { sentryReport } from '../../helpers/sentry';
import { showErrorMessage } from '../../helpers/showMessage';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { Body5, Headline3 } from '../../app/common/typography';
import { getMyAuditCounts } from '../../requests/myAudit';
import { IListSelector } from '../../app/@types/subHeaderSelector';
import { LineHeader } from '../../app/pages/MyAudit/MyAuditChecklist/MyAuditChecklist.styled';
import { SubHeaderSelector } from '../../app/common/sharedComponents/SubHeaderSelector';
import { useNotificationRequest } from '../../app/common/hooks/useNotificationRequest';
import { INotificationParams } from 'src/app/@types/notification';
import { TabPill } from './../../app/common/sharedComponents/TabPill';
import { UserTypeEnum } from '../../app/common/enum/generic';

const MyActions = () => {
  const [listSelector, setListSelector] = useState<IListSelector[]>([]);
  const [valueHeaderSelector, setValueHeaderSelector] = useState<string>();
  const [titleHeaderSelector, setTitleHeaderSelector] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);
  const [openPressAndHold, setOpenPressHold] = useState(false);
  const [notificationsData, setNotificationsData] = useState<any>(undefined);
  const [counts, setCounts] = useState({
    actionPlans: 0,
    overdueActionPlans: 0,
    selfAssessments: 0,
    overdueSelfAssessments: 0,
    myAuditCounts: 0,
    overdueMyauditCounts: 0,
  });

  const { t } = useTranslation();
  const navigate = useNavigate();
  const hasHotelSelector = localStorage.getItem('hotelSelectorDropdown');
  const userData = getItem('user');
  const isViewer =
    userData && userData.user && userData.user.userType === UserTypeEnum.noData;
  const allhotels = getBrandAndHotelData();
  const alreadyAssignedUsers =
    userData && userData.user && userData.user.id ? [userData.user.id] : [];
  const createActionPlanHandler = () => {
    navigate('/createActionPlan', {
      state: { alreadyAssignedUsers },
    });
  };

  const actionPlanListHandler = (OverDue = false) => {
    localStorage.setItem('action', 'individuals');
    navigate(`/actionPlanList?viewType=${type}&overDue=${OverDue}`);
  };

  const selfAssessmentListNavigate = (OverDue = false) => {
    navigate(`/SelfAssessments/${type}/${OverDue ? 'true' : 'false'}/all`);
  };
  const myAuditListHandler = (OverDue = false) => {
    navigate(`/myaudit?filterBy=${type}`, {
      state: { OverDue },
    });
  };

  const { selectedHotel } = userHotelDetails();
  const notificationParam: INotificationParams = {
    hotelId: selectedHotel,
    page: 1,
    pageSize: 10,
    sort: '-id',
    maxLastDay: 7,
  };

  const {
    notificationParams,
    hasMoreNotifications,
    setHasMoreNotifications,
    fetchNextNotificationData,
  } = useNotificationRequest(setNotificationsData, notificationParam);

  const options = [
    { value: 'received', label: t('COMMON.MY_ACTIONS.SELECTOR.RECEIVED') },
    { value: 'sent', label: t('COMMON.MY_ACTIONS.SELECTOR.SENT') },
  ];

  const [type, setType] = useState(options[0].value);

  const fetchNotificationsHandler = async () => {
    try {
      const { data } = await fetchNotifications(notificationParams);
      const parsedNotifications = data.results.map((notification: any) =>
        checkNotificationClickAnalizer(notification)
      );
      setHasMoreNotifications(notificationParams.page < data.numberOfPages);
      setNotificationsData(parsedNotifications);
      setItem('newNotificationsCounter', '0');
    } catch (error: any) {
      sentryReport(error.response.data, error.message, error.code, {
        summaryError: t('COMMON.ALERT_MESSAGES.UNABLE_TO_GET_NOTIFICATION'),
        path: '/myactions',
      });
      showErrorMessage(t('COMMON.ALERT_MESSAGES.UNABLE_TO_GET_NOTIFICATION'));
    }
  };

  useEffect(() => {
    const allHotels = getBrandAndHotelData();
    const selected = getItem('selectedHotel');

    if (selected && allHotels) {
      const { hotelName, brandName, hotelsWithSelection } =
        getInitialHotelSelectionData(allHotels);

      setListSelector(hotelsWithSelection);
      setTitleHeaderSelector(brandName);
      setValueHeaderSelector(hotelName);

      removeItem('apFilter');
      removeItem('saFilter');
    }
  }, []);

  useEffect(() => {
    if (userData && userData.user && allhotels && allhotels.length) {
      const selectedAssessmentId = getItem('selectedAssessmentId')
        ? getItem('selectedAssessmentId')
        : undefined;
      if (!selectedAssessmentId) {
        assessments().then((res) => {
          if (res && res.length) {
            setItem('selectedAssessmentId', res[0].id);
          }
          Promise.all([
            actionplansCount(),
            selfAssessmentsDashboardList(userData.user.id),
            getMyAuditCounts(),
          ]).then((res) => {
            const actionPlanResult = res[0];
            const selfAssessmentResult = res[1];
            const myAuditResult = res[2];
            if (type === 'sent') {
              setCounts({
                ...counts,
                actionPlans: actionPlanResult.sent,
                overdueActionPlans: actionPlanResult.sentDue,
                selfAssessments: selfAssessmentResult.sent,
                overdueSelfAssessments: selfAssessmentResult.sentDue,
                myAuditCounts: myAuditResult.data.createdByCount,
                overdueMyauditCounts: myAuditResult.data.createdByOverdueCount,
              });
            } else {
              setCounts({
                ...counts,
                actionPlans: actionPlanResult.recieved,
                overdueActionPlans: actionPlanResult.recievedDue,
                selfAssessments: selfAssessmentResult.recieved,
                overdueSelfAssessments: selfAssessmentResult.recievedDue,
                myAuditCounts: myAuditResult.data.auditorByCount,
                overdueMyauditCounts: myAuditResult.data.auditorByOverdueCount,
              });
            }
            setIsLoading(true);
            removeItem('apFilter');
            removeItem('saFilter');
          });
        });
      } else {
        Promise.all([
          actionplansCount(),
          selfAssessmentsDashboardList(userData.user.id),
          getMyAuditCounts(),
        ]).then((res) => {
          if (res && res.length) {
            const actionPlanResult = res[0];
            const selfAssessmentResult = res[1];
            const myAuditResult = res[2].data;
            if (type === 'sent') {
              setCounts({
                ...counts,
                actionPlans: actionPlanResult.sent,
                overdueActionPlans: actionPlanResult.sentDue,
                selfAssessments: selfAssessmentResult.sent,
                overdueSelfAssessments: selfAssessmentResult.sentDue,
                myAuditCounts: myAuditResult.createdByCount,
                overdueMyauditCounts: myAuditResult.createdByOverdueCount,
              });
            } else {
              setCounts({
                ...counts,
                actionPlans: actionPlanResult.recieved,
                overdueActionPlans: actionPlanResult.recievedDue,
                selfAssessments: selfAssessmentResult.recieved,
                overdueSelfAssessments: selfAssessmentResult.recievedDue,
                myAuditCounts: myAuditResult.auditorByCount,
                overdueMyauditCounts: myAuditResult.auditorByOverdueCount,
              });
            }
            setIsLoading(true);
            removeItem('apFilter');
            removeItem('saFilter');
          }
        });
      }
      (async () => {
        const selectedHotel = getItem('selectedHotel');
        await AuthMeRes();
        await SetDefaultTemplateId(selectedHotel);
      })();
    }
  }, [type, listSelector]);

  useEffect(() => {
    if (valueHeaderSelector) {
      (async () => {
        await fetchNotificationsHandler();
      })();
    }
  }, [valueHeaderSelector]);

  function clickHotelSelection (
    hotelId: string | number,
    clientId: string | number,
    brandId: string | number
  ) {
    const { updatedHotelList, selectedHotel } = updateHotelSelection(
      listSelector,
      hotelId,
      clientId,
      brandId
    );

    if (selectedHotel) {
      setTitleHeaderSelector(selectedHotel.brandName);
      setValueHeaderSelector(selectedHotel.name);
    }

    setListSelector(updatedHotelList);
  }

  if (
    !userData ||
    !userData.user ||
    !userData.user.brands ||
    !userData.user.brands.length ||
    userData.user.brands[0].hotels.length <= 0
  ) {
    return (
      <>
        <AccessDenied tabname={t('COMMON.MY_ACTIONS.TITLE')} />
      </>
    );
  }

  const pressAndHoldMenu = () => {
    return (
      <BottomSheet
        isOpen={openPressAndHold}
        onClose={() => setOpenPressHold(false)}
      >
        <BottomSheetContainer>
          <ButtonBlockColumn>
            <ButtonLarge
              title={t(
                'COMMON.MY_ACTIONS.BOTTOM_SHEET.BUTTONS.CREATE_ACTION_PLAN'
              )}
              onClick={createActionPlanHandler}
            />
            <ButtonLarge
              title={t(
                'COMMON.MY_ACTIONS.BOTTOM_SHEET.BUTTONS.CREATE_SELF_ASSESSMENT'
              )}
              onClick={() => {
                removeItem('parentAssessment');
                removeItem('selfAssessments');
                removeItem('disabledCategories');
                removeItem('selfAssessmentslocal');
                removeItem('saTemplateId');
                navigate('/selfAssessment/selectDepartments');
              }}
              outlined={true}
              inverted={true}
            />
            <ButtonLarge
              title={t(
                'COMMON.MY_ACTIONS.BOTTOM_SHEET.BUTTONS.CREATE_MY_AUDIT'
              )}
              onClick={() => {
                removeItem('myAudit');
                removeItem('editCard');
                navigate('/myaudit/checklist');
              }}
              outlined={true}
              inverted={true}
            />
          </ButtonBlockColumn>
        </BottomSheetContainer>
      </BottomSheet>
    );
  };

  return (
    <>
      <HeaderContainer>
        <AppHeader
          title={t('COMMON.MY_ACTIONS.ACTIONS.MY_ACTIONS')}
          hasBackButton={false}
        />
        {!hasHotelSelector && (
          <>
            <LineHeader />
            <SubHeaderSelector
              title={titleHeaderSelector}
              subTitle={valueHeaderSelector}
              listSelector={listSelector}
              clickSelectSection={clickHotelSelection}
            />
          </>
        )}
      </HeaderContainer>
      {!isLoading ? (
        <ContentArea>
          <div className="">
            <div className="">
              <div className="mb-20">
                <Skeleton
                  containerClassName="flex-1"
                  height={50}
                  borderRadius={25}
                />
              </div>

              <div className="center-align-skeleton ">
                <Skeleton width={200} height={200} circle={true} />
                <div className="h-13px" />
                <Skeleton width={100} height={30} />
              </div>
              <div className="mb-10 mt-80">
                <Skeleton
                  containerClassName="flex-1"
                  height={100}
                  borderRadius={5}
                />
                <Skeleton
                  containerClassName="flex-1"
                  height={100}
                  borderRadius={5}
                />
              </div>
              <Skeleton
                containerClassName="flex-1"
                height={50}
                borderRadius={5}
              />
            </div>
          </div>
        </ContentArea>
      ) : (
        <>
          <ContentArea>
            <ControlSelectContainer>
              <TabPill
                options={options}
                selected={type}
                handleClick={(value) => {
                  setType(value);
                }}
              />
            </ControlSelectContainer>
            <MenuContainer>
              <ChartContainer>
                <PatternIcon
                  svgClass="lefttop"
                  isOverDue={counts.overdueActionPlans > 0}
                />
                <LeftTopDetail onClick={() => actionPlanListHandler()}>
                  <CurvedText
                    text={t('COMMON.MY_ACTIONS.ACTIONS.ACTION_PLAN')}
                  />
                  <span>{counts.actionPlans}</span>
                </LeftTopDetail>
                <PatternIcon
                  svgClass="righttop"
                  color="#4FADA6"
                  isOverDue={counts.overdueSelfAssessments > 0}
                />
                <RightTopDetail onClick={() => selfAssessmentListNavigate()}>
                  <CurvedText
                    text={t('COMMON.MY_ACTIONS.ACTIONS.SELF_ASSESSMENT')}
                  />
                  <span>{counts.selfAssessments}</span>
                </RightTopDetail>
                <PatternIcon
                  svgClass="cbottom"
                  color="#FBBC05"
                  isOverDue={counts.overdueMyauditCounts > 0}
                />
                <BottomDetail onClick={() => myAuditListHandler()}>
                  <svg viewBox="0 0 500 500">
                    <path
                      id="curve2"
                      d="M73.2,351.4c4,6.1,65.5,96.8,178.6,95.6c111.3-1.2,170.8-90.3,175.1-97"
                      fill="transparent"
                    />
                    <text width="500" fill="#ffffff">
                      <textPath xlinkHref="#curve2" startOffset="50%">
                        {t('COMMON.MY_ACTIONS.ACTIONS.MY_AUDIT')}
                      </textPath>
                    </text>
                  </svg>
                  <TextMyAuditCount>{counts.myAuditCounts}</TextMyAuditCount>
                </BottomDetail>
                {!isViewer && (
                  <CenterDetail onClick={() => setOpenPressHold(true)}>
                    <TextCreatNew>
                      {t('COMMON.MY_ACTIONS.CREATE_NEW')}
                    </TextCreatNew>
                  </CenterDetail>
                )}
              </ChartContainer>
            </MenuContainer>

            <OverdueCountsContainer>
              {counts.overdueSelfAssessments > 0 && (
                <OverdueCountsContent
                  onClick={() => selfAssessmentListNavigate(true)}
                >
                  <RedDotContaier />
                  <Body5 color="eerieBlack">
                    {counts.overdueSelfAssessments}{' '}
                    {t('COMMON.MY_ACTIONS.ACTIONS.SELF_ASSESSMENT')}
                    {counts.overdueSelfAssessments > 1 ? 's' : ''}
                  </Body5>
                </OverdueCountsContent>
              )}
              {counts.overdueActionPlans > 0 && (
                <OverdueCountsContent
                  onClick={() => actionPlanListHandler(true)}
                >
                  <RedDotContaier />
                  <Body5 color="eerieBlack">
                    {counts.overdueActionPlans}{' '}
                    {t('COMMON.MY_ACTIONS.ACTIONS.ACTION_PLAN')}
                    {counts.overdueActionPlans > 1 ? 's' : ''}
                  </Body5>
                </OverdueCountsContent>
              )}
              {counts.overdueMyauditCounts > 0 && (
                <OverdueCountsContent onClick={() => myAuditListHandler(true)}>
                  <RedDotContaier />
                  <Body5 color="eerieBlack">
                    {counts.overdueMyauditCounts} {t('COMMON.MY_AUDIT.TITLE')}
                    {counts.overdueMyauditCounts > 1 ? 's' : ''}
                  </Body5>
                </OverdueCountsContent>
              )}
            </OverdueCountsContainer>
          </ContentArea>
          <NotificationContainer>
            <NotificationHeading>
              <Headline3>{t('COMMON.MY_ACTIONS.NOTIFICATIONS')}</Headline3>
            </NotificationHeading>
            {notificationsData && notificationsData.length > 0 ? (
              <NotificationList
                NotificationData={notificationsData}
                fetchNextNotificationData={fetchNextNotificationData}
                hasMoreNotifications={hasMoreNotifications}
              />
            ) : (
              <NotificationEmpty>
                <NoNotificationContents>
                  <NoNotification />
                </NoNotificationContents>
                <Headline3 color="eerieBlack">
                  {t('COMMON.MY_ACTIONS.NO_NOTIFICATIONS.TITLE')}
                </Headline3>
                <TextWrapper>
                  <Body5 color="dimGray">
                    {t('COMMON.MY_ACTIONS.NO_NOTIFICATIONS.MESSAGE')}
                  </Body5>
                </TextWrapper>
                {!isViewer && (
                  <ButtonContainer>
                    <ButtonLarge
                      title={t('COMMON.MY_ACTIONS.CREATE_NEW')}
                      onClick={() => setOpenPressHold(true)}
                    />
                  </ButtonContainer>
                )}
              </NotificationEmpty>
            )}
          </NotificationContainer>
          {pressAndHoldMenu()}
        </>
      )}
    </>
  );
};

export default MyActions;
